import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import TeacherDashboard from "../../Components/dashboard/teacherDashboard";
import { useUserStore } from "../../hooks/userHooks/user.hooks";
import { UserRole } from "../../Constants/userRole";
import AdminDashboard from "../../Components/dashboard/adminDashboard";
import ParentDashboard from "../../Components/dashboard/ParentDashboard";

const Dashboard = () => {
  const { user } = useUserStore();

  return (
    <Wrapper header={`${user?.role}'s dashboard`}>
      {user?.role === UserRole.ADMIN || user?.role === UserRole.SUPERADMIN ? (
        <AdminDashboard />
      ) : user?.role === UserRole.TEACHER ? (
        <TeacherDashboard />
      ) : user?.role === UserRole.USER ? (
        <ParentDashboard />
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
export default Dashboard;
